<div class="px-6 pt-4 pb-2 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center">
  <h2 class="text-xl font-semibold text-slate-900 dark:text-white">Generate Email</h2>
  <button mat-dialog-close>
    <mat-icon class="text-slate-500 dark:text-slate-300">close</mat-icon>
  </button>
</div>
<hr class="border-gray-200 dark:border-slate-700" />

<mat-dialog-content class="mat-typography email-generate-dialog-content">
  <div class="mb-6 p-4 bg-blue-50 dark:bg-blue-950/50 border border-blue-200 dark:border-blue-800 rounded-lg">
    <div class="flex items-start">
      <mat-icon class="text-blue-600 dark:text-blue-400 mr-3 mt-1">auto_awesome</mat-icon>
      <div>
        <h3 class="text-sm font-medium text-blue-900 dark:text-blue-200 mb-2">AI Email Writer</h3>
        <div class="text-sm text-blue-800 dark:text-blue-300 space-y-1">
          <p><strong>Description:</strong> Provide instructions and generate a subject + email body.</p>
          <p><strong>Tip:</strong> Include placeholders like <code class="bg-blue-100 dark:bg-blue-900/50 px-1 rounded text-blue-900 dark:text-blue-200">[[first_name]]</code> if needed.</p>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" novalidate>
    <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
      <div class="col-span-2">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
            <mat-icon class="text-gray-500 dark:text-slate-400 mr-2">email</mat-icon>
            Generated Result
          </h3>
          <button
            matButton="outlined"
            appearance="outline"
            type="button"
            [disabled]="isGenerating || !form.get('prompt')?.valid"
            (click)="generateEmail()"
          >
            Generate
          </button>
        </div>
      </div>

      <div class="col-span-2">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Generated Subject</mat-label>
          <mat-icon matPrefix class="text-gray-500 dark:text-slate-400">title</mat-icon>
          <input matInput type="text" formControlName="generated_subject" placeholder="Generated subject will appear here" />
        </mat-form-field>
      </div>

      <div class="col-span-2">
        <div class="email-generate-editor-host border border-gray-300 dark:border-slate-600 rounded-md overflow-x-auto overflow-y-visible bg-white dark:bg-slate-800">
          <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
          <div>
            <ngx-editor
              [editor]="editor"
              formControlName="generated_body"
              placeholder="Generated email body will appear here"
            ></ngx-editor>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<hr class="border-gray-200 dark:border-slate-700" />
<mat-dialog-actions align="end" class="px-6 py-4 bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700">
  <button [mat-dialog-close]="true" matButton="outlined" appearance="outline">Cancel</button>
  <button
    matButton="outlined"
    appearance="outline"
    type="button"
    [disabled]="!form.get('generated_body')?.value"
    (click)="useGenerated()"
  >
    Use
  </button>
</mat-dialog-actions>
